import { useEffect, useRef, useState, memo } from "react";

/* ================= IMAGES ================= */

import carboniteImg  from "../assets/images/partners/Carbonite.webp";
import ciscoImg      from "../assets/images/partners/Cisco.webp";
import commImg       from "../assets/images/partners/Comm.webp";
import dellImg       from "../assets/images/partners/Dell.webp";
import dynatraceImg  from "../assets/images/partners/Dynatrace.webp";
import f5Img         from "../assets/images/partners/F5.webp";
import huaweiImg     from "../assets/images/partners/Huawei.webp";
import ibmImg        from "../assets/images/partners/IBM.webp";
import microsoftImg  from "../assets/images/partners/Microsoft.webp";
import netappImg     from "../assets/images/partners/Netapp.webp";
import nvidiaImg     from "../assets/images/partners/Nvidia.webp";
import oracleImg     from "../assets/images/partners/Oracle.webp";
import packardImg    from "../assets/images/partners/Packard.webp";
import poImg         from "../assets/images/partners/Po.webp";
import qnapImg       from "../assets/images/partners/Qnap.webp";
import rImg          from "../assets/images/partners/R.webp";
import redhatImg     from "../assets/images/partners/Rehat.webp";
import stImg         from "../assets/images/partners/St.webp";
import vmImg         from "../assets/images/partners/VM.webp";
import veeamImg      from "../assets/images/partners/Veeam.webp";
import veritasImg    from "../assets/images/partners/Veritas.webp";
import vertivImg     from "../assets/images/partners/Vertiv.webp";
import zimbraImg     from "../assets/images/partners/Zimbra.webp";
import zycusImg      from "../assets/images/partners/Zycus.webp";
import bedImg        from "../assets/images/partners/bed.webp";
import fortinetImg   from "../assets/images/partners/fortinet.webp";
import lenovoImg     from "../assets/images/partners/lenovo.webp";
import nutanixImg    from "../assets/images/partners/nutnix.webp";

/* ================= DATA ================= */

const PARTNERS = [
  { name: "Carbonite",  src: carboniteImg },
  { name: "Cisco",      src: ciscoImg },
  { name: "Comm",       src: commImg },
  { name: "Dell",       src: dellImg },
  { name: "Dynatrace",  src: dynatraceImg },
  { name: "F5",         src: f5Img },
  { name: "Huawei",     src: huaweiImg },
  { name: "IBM",        src: ibmImg },
  { name: "Microsoft",  src: microsoftImg },
  { name: "NetApp",     src: netappImg },
  { name: "Nvidia",     src: nvidiaImg },
  { name: "Oracle",     src: oracleImg },
  { name: "HP Packard", src: packardImg },
  { name: "Po",         src: poImg },
  { name: "QNAP",       src: qnapImg },
  { name: "R",          src: rImg },
  { name: "Red Hat",    src: redhatImg },
  { name: "ST",         src: stImg },
  { name: "VMware",     src: vmImg },
  { name: "Veeam",      src: veeamImg },
  { name: "Veritas",    src: veritasImg },
  { name: "Vertiv",     src: vertivImg },
  { name: "Zimbra",     src: zimbraImg },
  { name: "Zycus",      src: zycusImg },
  { name: "Bed",        src: bedImg },
  { name: "Fortinet",   src: fortinetImg },
  { name: "Lenovo",     src: lenovoImg },
  { name: "Nutanix",    src: nutanixImg },
];

/* ================= ITEM ================= */

const LogoItem = memo(({ logo }) => (
  <div className="partners-logo">
    <img
      src={logo.src}
      alt={logo.name}
      loading="lazy"
      decoding="async"
    />
  </div>
));

LogoItem.displayName = "LogoItem";

/* ================= MAIN ================= */

export default function Partners() {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  // duplicate once for seamless loop
  const logos = [...PARTNERS, ...PARTNERS];

  return (
    <section className="partners-section-wrap" ref={containerRef}>
      <div className="partners-container">
        <div className={`partners-track ${isVisible ? "animate" : ""}`}>
          {logos.map((logo, i) => (
            <LogoItem key={i} logo={logo} />
          ))}
        </div>
      </div>
    </section>
  );
}
